import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 py-10 border-t border-slate-900" data-testid="main-footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center font-bold text-[#0A192F] text-sm">LS</div>
              <span className="font-bold text-white text-lg">Lualaba Services</span>
            </div>
            <p className="text-sm max-w-sm mb-4">
              Plateforme provinciale de services citoyens. Ce portail est un projet proposé au Gouvernement provincial du Lualaba pour faciliter l'accès aux services publics et valoriser les actions de développement.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/demander-aide" className="hover:text-blue-400 transition-colors">Demander de l'aide</Link></li>
              <li><Link to="/trouver-service" className="hover:text-blue-400 transition-colors">Trouver une structure</Link></li>
              <li><Link to="/signaler" className="hover:text-blue-400 transition-colors">Signaler un problème</Link></li>
              <li><Link to="/suivi" className="hover:text-blue-400 transition-colors">Suivre mon dossier</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Légal & Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>Opérateur : <span className="font-medium">GLOTECH DIGITAL</span></li>
              <li>Téléphone : <span className="font-medium">+243 97 123 4567</span></li>
              <li className="pt-2"><Link to="/confidentialite" className="text-blue-400 hover:text-blue-300">Politique de confidentialité</Link></li>
              <li><a href="mailto:support@lualabaservices.cd" className="text-blue-400 hover:text-blue-300">Réclamations & Support</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-slate-800 text-xs flex flex-col md:flex-row justify-between items-center gap-4">
          <p>&copy; {new Date().getFullYear()} Lualaba Services. Projet proposé - Tous droits réservés.</p>
          <p>Conception : <span className="text-blue-400 font-medium">GLOTECH DIGITAL</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
